module.exports = "/assets/8a64668b9bfa688a30195b6382bf2444.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P0.png
// module id = 1699
// module chunks = 0